// extracted by mini-css-extract-plugin
module.exports = {"BenefitsCalc":"styles_BenefitsCalc__3lT0i","BenefitsCalc_wrapper":"styles_BenefitsCalc_wrapper__2qNa7","BenefitsCalc_imageSide":"styles_BenefitsCalc_imageSide__3c2Bx"};